import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// import { getAuth, onAuthStateChanged} from 'firebase/auth'

var firebaseConfig = {
  apiKey: "AIzaSyCYbQiWwIWAaKYyyZTPkapnbNk79-UPObg",
  authDomain: "kashoo-voting.firebaseapp.com",
  projectId: "kashoo-voting",
  storageBucket: "kashoo-voting.appspot.com",
  messagingSenderId: "1030019623673",
  appId: "1:1030019623673:web:7c5b0e6d565ef633685028"
}

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
// export const auth = getAuth(firebaseApp)
export const db = firebase.firestore();